import { render, staticRenderFns } from "./AccessibilityOption.vue?vue&type=template&id=7cc96863&scoped=true&"
import script from "./AccessibilityOption.vue?vue&type=script&lang=js&"
export * from "./AccessibilityOption.vue?vue&type=script&lang=js&"
import style0 from "./AccessibilityOption.vue?vue&type=style&index=0&id=7cc96863&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc96863",
  null
  
)

/* custom blocks */
import block0 from "./AccessibilityOption.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports